import { createRpcClientV2 } from 'rpc-client-utils';
import { getTranscriptionStatusRpc } from '../../__generated__/chirp/com/hubspot/calls/rpc/CallsCheckTranscriptChirpService';
import http from 'hub-http/clients/apiClient';
import { useState, useEffect, useCallback } from 'react';
import { logError } from 'calling-error-reporting/report/error';
const rpcClient = createRpcClientV2({
  hubHttpClient: http
});
export const useGetTranscriptionStatus = (crmObjectId, pollFrequency = 15000) => {
  const [isLoading, setIsLoading] = useState(true);
  const [disabledReason, setDisabledReason] = useState(null);
  const [shouldSummarize, setShouldSummarize] = useState(false);
  const getTranscriptionStatus = useCallback(async () => {
    if (crmObjectId) {
      const myRequestPayload = {
        callCrmObjectId: crmObjectId
      };
      const response = await rpcClient.call(getTranscriptionStatusRpc, {
        request: myRequestPayload
      }).catch(error => {
        logError({
          error,
          tags: {
            requestName: 'get-transcription-status'
          }
        });
      });
      if (response) {
        if (response.shouldPollForSummary) {
          // loading state
          setTimeout(getTranscriptionStatus, pollFrequency);
        } else {
          setIsLoading(false);
          setShouldSummarize(!!response.shouldSummarize);
          setDisabledReason(response.summaryIneligibilityReason || null);
        }
      } else {
        // some kind of error outside the scope of this wrapper, just try and show the summary
        setIsLoading(false);
        setShouldSummarize(true);
        setDisabledReason(null);
      }
    }
  }, [crmObjectId, pollFrequency]);
  useEffect(() => {
    getTranscriptionStatus().catch(() => {
      // do nothing
    });
  }, [getTranscriptionStatus]);
  return {
    isDisabled: !shouldSummarize || isLoading,
    // There is something very weird going on with the generated types for chirp
    disabledReason: disabledReason
  };
};